import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-success-message',
    templateUrl: './success-message.component.html',
    styleUrls: ['./success-message.component.scss'],
    standalone: false
})
export class SuccessMessageComponent {
  @Input()
  public message: string;
}
